module.exports = __webpack_public_path__ + "static/scale-model-of-nasher-sculpture-center-in-dallas-texas-226ce26319e8d83e5b5da5cf787690ab.png";